/**
 * Gets the error title based on the error step
 * @param step - The error step number
 * @returns Error title string
 */
export const getErrorTitle = (step: number): string => {
  switch (step) {
    case 1:
      return "Unable to Generate Enrollment Form Error";
    case 2:
      return "Unable to Send Signature Request";
    case 3:
      return "Link No Longer Valid";
    case 4:
      return "System Sync Issue";
    default:
      return "Enrollment Processing Error";
  }
};

/**
 * Gets the error details based on the error step
 * @param step - The error step number
 * @returns Error details string
 */
export const getErrorDetails = (step: number): string => {
  switch (step) {
    case 1:
      return "We encountered an issue creating your SDCP enrollment document. This may be due to missing project data or a temporary system issue.";
    case 2:
      return "We couldn't deliver the signature request email to customer@email.com. Please verify the email address and retry.";
    case 3:
      return "This signature link has expired for security reasons. Don't worry - we can send you a new link to complete your SDCP enrollment.";
    case 4:
      return "Your document has been signed successfully, but there's a delay in updating your project status. The system will automatically sync within the next few minutes.";
    default:
      return "An error occurred during the enrollment process. Please try again or contact support if the issue persists.";
  }
};

/**
 * Handles retry logic based on the error step
 * @param errorStep - The step that failed
 */
export const handleRetry = (errorStep: number): void => {
  // TODO: Implement retry logic based on the error step
  console.log(`Retrying step ${errorStep}`);
};

/**
 * Handles contact support logic
 */
export const handleContactSupport = (): void => {
  // TODO: Implement contact support logic
  console.log("Contacting support");
};
